module.exports = __webpack_public_path__ + "img/ctrl-berkeley-dagger-stub-1.4189ef87.svg";